import React from "react";
import { FaGlobe } from "react-icons/fa"; // Import globe icon
import hnImage from "../assets/hn.jpeg";
import amImage from "../assets/AM.jpeg";
import whatsappImage from "../assets/WhatsApp.jpeg";

// Card Component
const Card = ({ className, children, ...props }) => {
  return (
    <div
      className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const Positionrespons = () => {
  const positions = [
    {
      title: "Core Technical Member",
      organization: "Codekrafters",
      image: hnImage,
      link: "https://www.linkedin.com/company/codechef-srmrmp/",
      linkColor: "text-gray-500",
      translateY: true
    },
    {
      title: "Technical Lead",
      organization: "GeeksforGeeks Student Chapter SRM Ramapuram",
      image: amImage,
      link: "https://www.linkedin.com/company/geeksforgeeks-srm-rmp/",
      linkColor: "text-green-500",
      translateY: false
    },
    {
      title: "Operational Head",
      organization: "99th Floor",
      image: whatsappImage,
      link: "https://www.linkedin.com/company/99thfloor/",
      linkColor: "text-blue-500",
      translateY: true
    }
  ];

  return (
    <div className="min-h-screen bg-[#d072fc] p-4 sm:p-6 md:p-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl pt-4 sm:pt-6 md:pt-8 font-bold text-center mb-4 md:mb-8">
          POSITION OF RESPONSIBILITY
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 relative mb-12 md:mb-20">
          {positions.map((position, index) => (
            <Card 
              key={index}
              className={`bg-white border-2 border-black overflow-hidden transition-transform hover:scale-105 ${
                position.translateY ? 'transform sm:translate-y-[30px] md:translate-y-[50px]' : ''
              }`}
            >
              <div className="p-4 sm:p-6">
                <div className="relative mb-4">
                  <img
                    src={position.image}
                    alt={position.title}
                    className="w-full h-[400px] object-cover rounded-lg border-2 border-black"
                  />
                </div>
                <div className="text-center">
                  <h3 className="font-medium text-base sm:text-lg mb-1 sm:mb-2">{position.title}</h3>
                  <p className="text-gray-600 text-xs sm:text-sm flex flex-col items-center">
                    {position.organization}
                    <a 
                      href={position.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className={`mt-2 ${position.linkColor}`}
                    >
                      <FaGlobe size={20} className="sm:text-xl md:text-2xl" />
                    </a>
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Positionrespons;